/**
 * Distinguishes a real row activation from a leftover click after a portaled
 * overlay (status filter) closes. Those ghost clicks fire `click` on the row
 * without a matching `pointerdown` on it, which previously marked NEW entries
 * as SEEN just by changing a filter.
 *
 * Keyboard (Enter/Space) synthesizes `click` with `detail === 0` and no
 * pointerdown — that is still intentional.
 */
export function isIntentionalInboxRowActivate(
  event: { detail: number },
  pointerDownEntryId: string | null,
  entryId: string,
): boolean {
  if (pointerDownEntryId === entryId) return true;
  return event.detail === 0;
}
